import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetUserGroupsQuery, useGetUserByDealerDropdownQuery } from '../../../../api';

/**
 * Teknisyen satırı için tekli DMS kullanıcı seçim dropdown'u (Ad Soyad). `UserDropdown`
 * (Katılımcılar alanı) ile aynı veri kaynaklarını kullanır ama MultiSelect yerine tekli
 * Dropdown döner — her teknisyen satırı tek bir userId taşır. `dealerScoped` bayi rolündeki
 * kullanıcı için yalnızca kendi bayisindeki personeli listeler (Katılımcılar alanıyla aynı kural).
 */
const TechnicianUserDropdown = ({ value, onChange, dealerScoped = false, placeholder, disabled = false, className = '' }) => {
    const { data: allUsersResponse, isLoading: isLoadingAllUsers } = useGetUserGroupsQuery(undefined, { skip: dealerScoped });
    const { data: dealerUsersResponse, isLoading: isLoadingDealerUsers } = useGetUserByDealerDropdownQuery(undefined, { skip: !dealerScoped });
    const userGroupsResponse = dealerScoped ? dealerUsersResponse : allUsersResponse;
    const isLoading = dealerScoped ? isLoadingDealerUsers : isLoadingAllUsers;

    const options = useMemo(() => (userGroupsResponse?.data || []).map((user) => ({ id: user.id, name: user.name, displayValue: `${user.id} - ${user.name}` })), [userGroupsResponse?.data]);

    return (
        <Dropdown
            value={value ?? null}
            options={options}
            optionLabel="displayValue"
            optionValue="id"
            onChange={(e) => onChange(e.value)}
            placeholder={placeholder}
            loading={isLoading}
            disabled={disabled}
            filter
            showClear
            filterBy="id,name"
            className={className}
            itemTemplate={(option) => (
                <div>
                    <span style={{ fontWeight: 'bold' }}>{option.id}</span> - {option.name}
                </div>
            )}
        />
    );
};

export default TechnicianUserDropdown;
